export default "__VITE_ASSET__2591b3b9__"